import { render, staticRenderFns } from "./gasClamp.vue?vue&type=template&id=a2d1fd8e&scoped=true&lang=pug"
import script from "./gasClamp.vue?vue&type=script&lang=js"
export * from "./gasClamp.vue?vue&type=script&lang=js"
import style0 from "./gasClamp.vue?vue&type=style&index=0&id=a2d1fd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d1fd8e",
  null
  
)

export default component.exports